<template>
  <div class="offer-current">
    <div class="row offer-current-params">
      <div class="col-4"></div>
      <div class="col-2">
        <b-form-group label="Data ważności</code>">
          <b-form-input type="date"  v-model="expire" />
        </b-form-group>
      </div>


      <div class="col-2">
        <b-form-group label="Marża">
          <b-form-radio-group id="radios1" v-model="offer.markupType" :options="markupTypes" name="markupTypes">
          </b-form-radio-group>
        </b-form-group>
      </div>

      <div class="col-3">
        <b-form-group label="&nbsp;">
          <b-input-group :append="offer.markupType == 'percent' ? '%' : 'zł'">
            <b-form-input type="number" v-model="offer.markupValue" min="0" :step="0.01"></b-form-input>
          </b-input-group>
        </b-form-group>
      </div>
      <div class="col-1">
        <b-form-group label="&nbsp;">
          <button class="btn btn-default btn-success text-white" @click="saveOffer()">Zapisz</button>
        </b-form-group>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table offer-conf">
        <thead>
          <tr>
            <th scope="col" class="photo"></th>
            <th scope="col" class="name">Nazwa</th>
            <th scope="col" class="quantity">Ilość</th>
            <th scope="col" class="net">Cena jedn. netto </th>
            <th scope="col" class="vat">VAT</th>
            <th scope="col" class="gross">Cena jedn. brutto</th>
            <th scope="col" class="gross">Razem brutto</th>
            <th scope="col" class="action"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="product in buildDataList">
            <td scope="col" class="photo position"><img :src="product.image" class="img-fluid" /></td>
            <td scope="col" class="name position">
              <router-link :to="{ name: 'productPage', params:{id: product.id, slug: 'item'}}" target="_blank">
                {{product.name}}
              </router-link>
            </td>
            <td scope="col" class="quantity position">
              <b-form-input type="number" v-model="product.cart_quantity" min="0" :step="findStep(product.unit)"  @change="savePosition(product)"></b-form-input>
            </td>
            <td scope="col" class="net position">
              <span v-if="product.setPrice <= 0" @click="setPrice(product)">
                {{calculateClientOfferPriceString(product.netPrice, product.tax, 1, 'net', currency(), offer.markupType,offer.markupValue)}}
              </span>
              <span v-else>
                <b-form-input type="number" v-model="product.setPrice" min="0" :step="0.01" @change="savePosition(product)" ></b-form-input>
                <span class="price-remove"  @click="removeSetPrice(product)">usuń</span>
              </span>
            </td>
            <td scope="col" class="vat position">
              <span v-if="product.setPrice <= 0">
                {{calculateClientOfferTaxString(product.netPrice, product.tax, 1, currency(), offer.markupType,offer.markupValue)}}
              </span>
              <span v-else>
                {{priceToString(calculateOfferPrice(Number(product.setPrice), product.tax, 1, 'gross', currency()) - calculateOfferPrice(Number(product.setPrice), product.tax, 1, 'net', currency()), currency().currency.symbol)}}
              </span>
            </td>
            <td scope="col" class="gross position">
              <span v-if="product.setPrice <= 0">
                {{calculateClientOfferPriceString(product.netPrice, product.tax, 1, 'gross', currency(), offer.markupType,offer.markupValue)}}
              </span>
              <span v-else>
                {{priceToString(calculateOfferPrice(Number(product.setPrice), product.tax, 1, 'gross', currency()), currency().currency.symbol)}}
              </span>
            </td>
            <td scope="col" class="gross position">
              <span v-if="product.setPrice <= 0">
                {{calculateClientOfferPriceString(product.netPrice, product.tax, product.cart_quantity, 'gross', currency(), offer.markupType,offer.markupValue)}}
              </span>
              <span v-else>
                {{priceToString(calculateOfferPrice(Number(product.setPrice), product.tax,  product.cart_quantity, 'gross', currency()), currency().currency.symbol)}}
              </span>
            </td>
            <td scope="col" class="action position">
              <button class="btn btn-default btn-info text-white" @click="removeCmp(product)">Usuń</button>
            </td>
          </tr>
          <tr class="bg-info">
            <td colspan="6">Razem</td>
            <td>{{ priceToString(sumGross(), currency().currency.symbol) }}</td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>


<script>
  import { mapState, mapGetters } from 'vuex';
  import CalculatePrice from 'redbay-b2b-products/src/product/CalculatePrice'

  export default {
    data() {
      let date = new Date();
      return {
        expire: date.toISOString().substr(0,10),
        markupTypes: [
          { value: 'percent', text: 'Procent' },
          { value: 'price', text: 'Kwota' }
        ],
        units: {single:[], decimals: []},
        buildDataList: [],
        group: '',
        attributes: []
      }
    },

    computed: {
      ...mapState({
        offer: state => state.offer,
        productsList: state => state.offer.products,
        userSettings:  state => state.user.userSettings,
        userPrices: state => state.user.userPrices,
      }),
      ...mapGetters({
        currency: 'company/selectedCurrency'
      })
    },
    methods: {
      ...CalculatePrice(),


      findStep(unit) {
        if(this.units.decimals.indexOf(unit)>=0) {
          return 0.001;
        }
        return 1;
      },

      setPrice(product) {
        product.setPrice = this.calculateClientOfferPrice(product.netPrice, product.tax, 1,  'net', this.currency(),
          this.offer.markupType,this.offer.markupValue);
        this.savePosition(product);
      },

      removeSetPrice(product) {
        product.setPrice = -1;
        this.savePosition(product);
      },

      savePosition(product) {
        this.$store.dispatch('offer/save', product);
      },

      removeCmp(product) {
        this.$store.dispatch('offer/remove', product.variantId);
      },




      sumGross() {
        if (this.buildDataList) {
          return this.buildDataList
            .map(product => product.setPrice <= 0 ?
              Math.round(this.calculateClientOfferPrice(product.netPrice, product.tax, product.cart_quantity,
                'gross', this.currency(), this.offer.markupType,this.offer.markupValue) *100) /100 :
              Math.round(this.calculateOfferPrice(Number(product.setPrice), product.tax, product.cart_quantity,
                 'gross', this.currency()) * 100) / 100)
            .reduce((a, b) => a + b, 0);
        }
        return 0;
      },


      async saveOffer() {
        let request ={
          expire: this.expire,
          description: '',
          positions: this.buildDataList.map(product => {
            return {
              variant_id: product.variantId,
              quantity: product.cart_quantity,
              net: product.setPrice <= 0 ?
                Math.round(this.calculateClientOfferPrice(product.netPrice, product.tax, 1,
                 'net', this.currency(), this.offer.markupType,this.offer.markupValue) * 100) / 100 :
                Math.round(product.setPrice * 100) / 100,
              tax: product.setPrice <= 0 ?
                Math.round(this.calculateClientOfferTax(product.netPrice, product.tax, 1,
                  this.currency(), this.offer.markupType,this.offer.markupValue) * 100) / 100 :
                Math.round(this.calculateOfferPrice(Number(product.setPrice), product.tax, 1,
                  'gross', this.currency()) * 100) / 100 - Math.round(product.setPrice * 100) / 100,
              gross: product.setPrice <= 0 ?
                Math.round(this.calculateClientOfferPrice(product.netPrice, product.tax, 1,
                  'gross', this.currency(), this.offer.markupType,this.offer.markupValue) *100) /100 :
                Math.round(this.calculateOfferPrice(Number(product.setPrice), product.tax, 1,
                  'gross', this.currency()) * 100) / 100
            }
          })
        };
        await this.$store.dispatch('offer/saveoffer', request);
        this.$router.replace({ name: 'offerList'});
      }



    },

    watch: {
      productsList: async function () {
        this.buildDataList = await this.$store.dispatch('offer/getDataList', {
          attributes: this.attributes, prices: this.userPrices, group: this.group
        });
      }
    },


    async beforeMount() {
      this.group = this.userSettings['USER_GROUP'] ? this.userSettings['USER_GROUP'] : 0;
      this.attributes = this.$config.get('searchPage.visibleAttributes');
      this.units = this.$config.get('basket.units');
      if(this.offer.markupType == null) {
        this.offer.markupType = this.userSettings.B2B_CLIENT_MARGIN_TYPE;
        this.offer.markupValue = this.userSettings.B2B_CLIENT_MARGIN;
      }

      this.buildDataList = await this.$store.dispatch('offer/getDataList', {
        attributes: this.attributes, prices: this.userPrices, group: this.group
      });
    }
  }
</script>



// WEBPACK FOOTER //
// node_modules/redbay-b2b-offer/src/OfferConf.vue